import { FunctionComponent, memo } from "react";
import { RemoteVideo, RosterAttendeeType, useAttendeeStatus, useRemoteVideoTileState } from 'amazon-chime-sdk-component-library-react';
import Avatar from '@mui/material/Avatar';
import './RemoteVideos.scss';
import images from "../../assets/images";
import { getInitials } from "../../utils/chimeHelper";
import { useChimeMeeting } from "../../Chime/ChimeMeetingContext";

type props = {
    Attendee: RosterAttendeeType & { color: string }
    hand: boolean
    isMainTile?: boolean
    hostId : string;
}

const RemoteVideos:FunctionComponent<props> = ({Attendee, hand, isMainTile, hostId}) => {
     console.log('remotevideo attendee data=====>',Attendee)
    const {
        muted,
        videoEnabled,
        sharingContent,
        signalStrength
      } = useAttendeeStatus(Attendee.chimeAttendeeId);
    const {Microphone, MicrophoneOff, ParticipantRaiseHand} = images;
    const { attendeeIdToTileId } = useRemoteVideoTileState();
    const { muteParticipant , userId} = useChimeMeeting();

    console.log('Attendee+======>',Attendee);
    console.log('[User] ----------------------------------')
    console.log('[User] Name',Attendee.name)
    console.log('[User] audio',muted)
    console.log('[User] video',videoEnabled)
    console.log('[User] screenshare',sharingContent)
    console.log('[User] signalstrength', signalStrength)
    console.log('[User] attendeeIdToTileId[Attendee.chimeAttendeeId]',attendeeIdToTileId[Attendee.chimeAttendeeId])
    console.log('[User] attendeeIdToTileId',attendeeIdToTileId)
    console.log('[User] Attendee',Attendee)
    console.log('[User] ----------------------------------')

    return(
        <div className={isMainTile ? "localTileContainer" :"remote-tile-innerContainer"}>
             <div className={isMainTile ? "iconsContainer" : "remote-tile-icon"}>
                <div className="micIconContainer">
                    <img 
                        src={ (muted) ? MicrophoneOff : Microphone } 
                        className={"micIcon"} 
                        alt="videoOn" 
                        onClick={() => ((userId === hostId ) && !muted) ? muteParticipant(Attendee?.chimeAttendeeId) : ""} 
                    />
                </div>
                <div className="handIconContainer">
                    <img src={ParticipantRaiseHand} className={hand ? 'raiseHandStyle' : 'raiseHandHidden'} alt="videoOn"/>
                </div>
            </div>
        {
            videoEnabled ?
                <>
                    <RemoteVideo
                        tileId={attendeeIdToTileId[Attendee.chimeAttendeeId]}
                        // name={Attendee.name} 
                        key={Attendee.externalUserId ?? Attendee.chimeAttendeeId}
                        className={`remote-video${attendeeIdToTileId[Attendee.chimeAttendeeId]}  remote-video ${isMainTile ? "remote-video-main" : ""}`}
                    />
                    <div className="participantName"><span style={{ textShadow: "0 1px 2px rgba(0,0,0,.6),0 0 2px rgba(0,0,0,.3)", letterSpacing: "1px" }}>
                        {Attendee.name ?
                            `${(Attendee?.name)?.charAt(0).toUpperCase() + (Attendee?.name)?.slice(1)} ${Attendee.externalUserId === hostId ? `(Host)` : ''}`
                            : ""}
                    </span></div>
                </>
                :
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', backgroundColor: 'black'}} className="remote-video">
                    <Avatar 
                        sx={{ 
                            width: isMainTile ? 150 : 80, 
                            height: isMainTile ? 150 : 80, 
                            fontSize: isMainTile ? "70px" : "24px", 
                            fontWeight:600, 
                            zIndex: 1, 
                            backgroundColor: Attendee?.color
                        }}
                    >{getInitials(Attendee.name)}</Avatar>
                    <div className="participantName"><span style={{ textShadow: "0 1px 2px rgba(0,0,0,.6),0 0 2px rgba(0,0,0,.3)", letterSpacing: "1px" }}>
                        {Attendee.name ?
                            `${(Attendee?.name)?.charAt(0).toUpperCase() + (Attendee?.name)?.slice(1)} ${Attendee.externalUserId === hostId ? `(Host)` : ''}`
                            : ""}
                    </span></div>
                </div>
        }
        </div>
    )
}

export default memo(RemoteVideos);
